import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TurnInto = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 36 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <g filter="url(#filter0_b_2591_9548)">
        <rect
          x="4.74829"
          y="4.92297"
          width="12.9576"
          height="8.33998"
          rx="2"
          fill="url(#paint0_linear_2591_9548)"
          fillOpacity="0.8"
        />
        <rect
          x="4.99829"
          y="5.17297"
          width="12.4576"
          height="7.83998"
          rx="1.75"
          stroke="url(#paint1_linear_2591_9548)"
          strokeOpacity="0.6"
          strokeWidth="0.5"
        />
      </g>
      <g filter="url(#filter1_b_2591_9548)">
        <rect
          x="22.8481"
          y="14.135"
          width="8.56708"
          height="16.9931"
          rx="2"
          fill="url(#paint2_linear_2591_9548)"
          fillOpacity="0.8"
        />
        <rect
          x="23.0981"
          y="14.385"
          width="8.06708"
          height="16.4931"
          rx="1.75"
          stroke="url(#paint3_linear_2591_9548)"
          strokeOpacity="0.6"
          strokeWidth="0.5"
        />
      </g>
      <g filter="url(#filter2_b_2591_9548)">
        <rect
          x="18.4575"
          y="4.92297"
          width="12.9576"
          height="8.33998"
          rx="2"
          fill="url(#paint4_linear_2591_9548)"
          fillOpacity="0.8"
        />
        <rect
          x="18.7075"
          y="5.17297"
          width="12.4576"
          height="7.83998"
          rx="1.75"
          stroke="url(#paint5_linear_2591_9548)"
          strokeOpacity="0.6"
          strokeWidth="0.5"
        />
      </g>
      <g filter="url(#filter3_b_2591_9548)">
        <rect
          x="4.74829"
          y="23.2025"
          width="8.08962"
          height="7.92623"
          rx="2"
          fill="url(#paint6_linear_2591_9548)"
          fillOpacity="0.8"
        />
        <rect
          x="4.99829"
          y="23.4525"
          width="7.58962"
          height="7.42623"
          rx="1.75"
          stroke="url(#paint7_linear_2591_9548)"
          strokeOpacity="0.6"
          strokeWidth="0.5"
        />
      </g>
      <g filter="url(#filter4_b_2591_9548)">
        <rect
          x="14.052"
          y="23.2025"
          width="7.83407"
          height="7.92623"
          rx="2"
          fill="url(#paint8_linear_2591_9548)"
          fillOpacity="0.8"
        />
        <rect
          x="14.302"
          y="23.4525"
          width="7.33407"
          height="7.42623"
          rx="1.75"
          stroke="url(#paint9_linear_2591_9548)"
          strokeOpacity="0.6"
          strokeWidth="0.5"
        />
      </g>
      <g filter="url(#filter5_b_2591_9548)">
        <rect
          x="4.74829"
          y="14.135"
          width="17.1377"
          height="8.11842"
          rx="2"
          fill="url(#paint10_linear_2591_9548)"
          fillOpacity="0.8"
        />
        <rect
          x="4.99829"
          y="14.385"
          width="16.6377"
          height="7.61842"
          rx="1.75"
          stroke="url(#paint11_linear_2591_9548)"
          strokeOpacity="0.6"
          strokeWidth="0.5"
        />
      </g>
      <defs>
        <filter
          id="filter0_b_2591_9548"
          x="1.74829"
          y="1.92297"
          width="18.9575"
          height="14.34"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1.5" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2591_9548" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2591_9548" result="shape" />
        </filter>
        <filter
          id="filter1_b_2591_9548"
          x="19.8481"
          y="11.135"
          width="14.5671"
          height="22.9932"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1.5" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2591_9548" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2591_9548" result="shape" />
        </filter>
        <filter
          id="filter2_b_2591_9548"
          x="15.4575"
          y="1.92297"
          width="18.9575"
          height="14.34"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1.5" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2591_9548" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2591_9548" result="shape" />
        </filter>
        <filter
          id="filter3_b_2591_9548"
          x="1.74829"
          y="20.2025"
          width="14.0896"
          height="13.9262"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1.5" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2591_9548" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2591_9548" result="shape" />
        </filter>
        <filter
          id="filter4_b_2591_9548"
          x="11.052"
          y="20.2025"
          width="13.834"
          height="13.9262"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1.5" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2591_9548" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2591_9548" result="shape" />
        </filter>
        <filter
          id="filter5_b_2591_9548"
          x="1.74829"
          y="11.135"
          width="23.1377"
          height="14.1184"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="1.5" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2591_9548" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2591_9548" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_2591_9548"
          x1="9.45912"
          y1="9.48265"
          x2="12.5491"
          y2="4.30423"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F335BE" />
          <stop offset="0.295" stopColor="#F33551" />
          <stop offset="1" stopColor="#FF8B04" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2591_9548"
          x1="10.7902"
          y1="4.92302"
          x2="10.7902"
          y2="13.9022"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2591_9548"
          x1="25.9628"
          y1="23.4256"
          x2="31.9678"
          y2="20.16"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F335BE" />
          <stop offset="0.295" stopColor="#F33551" />
          <stop offset="1" stopColor="#FF8B04" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2591_9548"
          x1="26.8428"
          y1="14.1351"
          x2="26.8428"
          y2="32.4306"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2591_9548"
          x1="23.1683"
          y1="9.48265"
          x2="26.2583"
          y2="4.30423"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F335BE" />
          <stop offset="0.295" stopColor="#F33551" />
          <stop offset="1" stopColor="#FF8B04" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2591_9548"
          x1="24.4994"
          y1="4.92302"
          x2="24.4994"
          y2="13.9022"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2591_9548"
          x1="7.68933"
          y1="27.5359"
          x2="11.0109"
          y2="23.8792"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F335BE" />
          <stop offset="0.295" stopColor="#F33551" />
          <stop offset="1" stopColor="#FF8B04" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_2591_9548"
          x1="8.52032"
          y1="23.2025"
          x2="8.52032"
          y2="31.7362"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_2591_9548"
          x1="16.9001"
          y1="27.5359"
          x2="20.2302"
          y2="23.9857"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F335BE" />
          <stop offset="0.295" stopColor="#F33551" />
          <stop offset="1" stopColor="#FF8B04" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_2591_9548"
          x1="17.7049"
          y1="23.2025"
          x2="17.7049"
          y2="31.7362"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_2591_9548"
          x1="10.9788"
          y1="18.5736"
          x2="13.4954"
          y2="12.8432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F335BE" />
          <stop offset="0.295" stopColor="#F33551" />
          <stop offset="1" stopColor="#FF8B04" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_2591_9548"
          x1="12.7393"
          y1="14.1351"
          x2="12.7393"
          y2="22.8757"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  )
})

export default TurnInto
